<span class="badge template-status-badge" [ngClass]="statusConfig.class">
  <i [class]="statusConfig.icon" class="me-1"></i>
  {{ statusConfig.label }}
</span>
